import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode, CruiseHighlightShape } from 'types';
import { CruiseHighlightPillProps, CruiseHighlightPillTextProps } from './CruiseHighlightList.types';

export const CruiseHighlightListBase = styled.div`
	display: inline-flex;
	flex-wrap: wrap;
	gap: 10px;
	padding-top: 20px;
	position: relative;
	width: 100%;

	@media (min-width: ${sizes.media.mediumMaxWidth}px) {
		padding-top: 30px;
	}

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
    `,
			[BrandCode.RoyalCaribbean]: `
      
    `,
		})[theme.brandCode]}
`;

export const CruiseHighlightPill = styled.div<CruiseHighlightPillProps>`
	align-items: center;
	display: inline-flex;
	font-weight: normal;
	justifiy-content: center;
	position: relative;

	${({ highlight }) => {
		if (highlight.shape === CruiseHighlightShape.Inclined) {
			return `
        height: 28px;
        padding: 4px 12px;
        transform: skew(-15deg);
      `;
		}

		return `
      border: 1px solid transparent;
      border-radius: 20px;
      height: 27px;
      padding: 5px 15px;
    `;
	}}

	${({ highlight, theme }) =>
		({
			[BrandCode.Celebrity]: `
      background-color: ${highlight.backgroundColor ?? theme.palette.special.main};
      border-color: ${highlight.borderColor ?? theme.palette.special.main};
      color: ${highlight.textColor ?? theme.palette.special.contrastText};
      font-family: ${theme.typography.fontFamilySemiBold};
      font-size: 11px;
      letter-spacing: 0.19px;
      line-height: 16px;
      text-transform: uppercase;
    `,
			[BrandCode.RoyalCaribbean]: `
      background-color: ${highlight.backgroundColor};
      border-color: ${highlight.borderColor};
      color: ${highlight.textColor};
      font-family: ${theme.typography.fontFamilySemiBold};
      font-size: 12px;
      letter-spacing: -0.02;
      line-height: 15px;
    `,
		})[theme.brandCode]}
`;

export const CruiseHighlightPillText = styled.span<CruiseHighlightPillTextProps>`
	${({ shape }) => {
		if (shape === CruiseHighlightShape.Inclined) {
			return `
        transform: skew(15deg);
      `;
		}
	}}
`;
